import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=dd3a60e0"
import script from "./Travel.vue?vue&type=script&lang=js"
export * from "./Travel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports